$(document).ready(function() {
    $('body').on('click', '[name="all"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Before continuing, you must check the box to replace all items currently in your cart with this collection. If you wish to add individual items afterword, you may do so, and it will not affect any previously added collections.");
        return false;
      }
    });
  });


